var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GLIcon',{staticClass:"quanping",attrs:{"icon":_vm.isFullscreen ? 'icon-suoxiao' : 'icon-quanping1'},nativeOn:{"click":function($event){return _vm.click.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }